<template>
  <div>
    <Pane />

    <div class="container">
      <a-form
        :form="form"
        @submit="handleSubmit"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 12 }"
        :colon="false"
      >
        <a-row>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item>
              <span class="required" slot="label">发起人</span>
              <a-button block style="text-align: left">
                {{ user.userName }}
              </a-button>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item>
              <span class="required" slot="label">发起部门</span>
              <a-button block style="text-align: left">
                {{ department.deptUniqueName }}
              </a-button>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item>
              <span class="required" slot="label">接收人</span>
              <EmployeeSelector
                @change="
                  (arr) => {
                    if (arr.length) {
                      selectedUser = arr[0];
                    } else {
                      selectedUser = {};
                    }
                  }
                "
                :value="selectedUser.name ? [selectedUser] : []"
              >
                <a-button
                  block
                  style="text-align: left"
                >
                  <div v-if="selectedUser.name">
                    {{ selectedUser.name }}
                  </div>
                  <div v-else>&nbsp;</div>
                </a-button>
              </EmployeeSelector>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item>
              <span class="required" slot="label">接收部门</span>
              <a-button block style="text-align: left">
                {{ selectedUser.deptUniqueName }}
              </a-button>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item
              label="移交说明"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 18 }"
            >
              <a-textarea
                :auto-size="{ minRows: 3 }"
                v-decorator="[
                  'description',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>

        <div class="between">
          <div class="title">移交固定资产清单</div>

        </div>
        <a-table
          bordered
          :dataSource="list"
          :pagination="false"
        >
          <a-table-column title="资产编码" data-index="assetCode"> </a-table-column>
          <a-table-column title="资产类别">
            <template slot-scope="text">
              <div style="display: flex;align-items: center">
                <DataDictFinder
                dictType="fixed_asset_type"
                :dictValue="text.category.categoryCode"
              />-
              {{text.category.subCategoryName}}
              </div>
            </template>
          </a-table-column>
          <a-table-column title="品牌型号" data-index="brandModel"> </a-table-column>
          <a-table-column title="采购日期" data-index="procurementTime"> </a-table-column>
          <a-table-column title="采购价格(元)" data-index="purchasePrice"> </a-table-column>
          <a-table-column title="资产负责人" data-index="responsiblePersonName"> </a-table-column>
          <a-table-column title="资产位置(部门)" data-index="deptName"> </a-table-column>
          <a-table-column title="财务编码" data-index="financialCode"> </a-table-column>
          <a-table-column title="启用日期" data-index="startTime"> </a-table-column>
          <a-table-column title="资产状态">
            <template slot-scope="text">
              <DataDictFinder
                dictType="fixed_asset_status"
                :dictValue="text.status"
                iconType="badge"
              />
            </template>
          </a-table-column>
          <a-table-column title="操作" align="center" width="100px">
            <template slot-scope="text, record, index">
              <a href="#" class="danger" @click.prevent="remove(index)"> 移除 </a>
            </template>
          </a-table-column>
        </a-table>

        <div class="center">
          <a-space>
            <a-button htmlType="submit" type="primary" :loading="loading">
              {{ id ? "重新提交" : "保存" }}
            </a-button>
            <a-button @click="$close($route.path)">关闭</a-button>
          </a-space>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import request from "@/api/request";
import { mapState, mapGetters } from "vuex";
import EmployeeSelector from "@/components/employee-selector";
function fetchApplyDetail(id) {
  return request({
    url: "/office-service/fixed-asset/hand-over/" + id,
    method: "post",
  });
}
function apply(data) {
  return request({
    url: "/office-service/fixed-asset/hand-over",
    data,
    method: "post",
  });
}
function reapply(data) {
  return request({
    url: "/office-service/fixed-asset/reHand-over",
    data,
    method: "post",
  });
}
export default {
  data() {
    return {
      index: 0,
      selectedUser: {},
      form: this.$form.createForm(this),

      list: [],

      loading: false,

      id: null, // 已发起申领申请的 id
    };
  },
  components: {
    EmployeeSelector,
  },
  mounted() {
    const { query } = this.$route;
    const { id } = query || {};

    if (id) {
      // 重新提交
      this.id = id;
      fetchApplyDetail(id).then((res) => {
        console.log("result", res);
        if (res) {
          this.form.setFieldsValue({
            description: res.description,
          });
          this.selectedUser = {
              deptId: res.receiverDeptId,
              deptUniqueName: res.receiverDeptName,
              userId: res.receiverId,
              name: res.receiverName,
          }    
          this.list = Array.isArray(res.fixedAssetList)
            ? res.fixedAssetList: [];
        }
      });
    }
    this.list = sessionStorage.getItem("handoverList") ? JSON.parse(sessionStorage.getItem("handoverList")) : [];

  },

  computed: {
    ...mapState("auth", ["user"]),
    ...mapGetters("auth", ["department"]),

    ...mapGetters("setting", ["findDataDict"]),

    typeList() {
      return this.findDataDict("giftType");
    },
  },

  methods: {
    showEmployeeSelector(index) {
      this.index = index;
    },
    addMaterial() {
      this.list.push({
        categoryId: "",
        desc: "",
        estimatedPrice: "",
        responsiblePersonId: "",
        responsiblePersonName: "",
      }) ;

    },
    renderSubType(type, subType) {
      const obj = this.typeList.find((item) => item.value === type);
      if (obj && Array.isArray(obj.children)) {
        const subTypeObj = obj.children.find((item) => item.value === subType);
        if (subTypeObj) {
          return subTypeObj.name;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },

    // 用户选择了品名和数量
    add(payload) {
      const index = this.list.findIndex((item) => item.id === payload.id);
      if (index === -1) {
        this.list.push(payload);
      } else {
        this.list.splice(index, 1, payload);
      }
    },

    remove(index) {
      this.list.splice(index, 1);
    },

    handleSubmit(e) {
      e.preventDefault();
      if(this.list.length === 0){
        this.$message.error("请添加固定资产");
        return;
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.list.length === 0) {
            this.$message.error("请添加固定资产");
            return;
          }
          if(!this.selectedUser.userId){
            this.$message.error("请选择接收人");
            return;
          }
          this.loading = true;

          if (this.id) {
            reapply({
              id: this.id ? this.id : undefined,
              description: values.description,
              applicantId: this.user.uuid,
              applicant: this.user.userName,
              applicantDeptId: this.department.deptId,
              applicantDeptName: this.department.deptUniqueName,
              receiverDeptId: this.selectedUser.deptId,
              receiverDeptName: this.selectedUser.deptUniqueName,
              receiverId: this.selectedUser.userId,
              receiverName: this.selectedUser.name,
              fixedAssetList: this.list
            })
              .then(() => {
                this.$close(this.$route.path);
              })
              .finally(() => {
                this.loading = false;
              });
          } else {
            apply({
              description: values.description,
              applicantId: this.user.uuid,
              applicant: this.user.userName,
              applicantDeptId: this.department.deptId,
              applicantDeptName: this.department.deptUniqueName,
              receiverDeptId: this.selectedUser.deptId,
              receiverDeptName: this.selectedUser.deptUniqueName,
              receiverId: this.selectedUser.userId,
              receiverName: this.selectedUser.name,
              fixedAssetList: this.list
            })
              .then(() => {
                this.$close(this.$route.path);
              })
              .finally(() => {
                this.loading = false;
              });
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 24px 160px;
}

.title {
  margin-top: 30px;
  margin-bottom: 18px;
  font-size: 14px;
  font-weight: bold;
  line-height: 22px;
  color: #1890ff;
}

.center {
  margin-top: 80px;
}
</style>
